import { render, staticRenderFns } from "./DeliveryCardContainer.vue?vue&type=template&id=4b70af43&"
import script from "./DeliveryCardContainer.vue?vue&type=script&lang=js&"
export * from "./DeliveryCardContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports